import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";
import Modal from "./components/modal/modal";
import { LoginPropsType, LoginStep } from "./types";
import Phone from "./components/phone";
import Otp from "./components/otp";
import Name from "./components/name";
import Email from "./components/email";
import Handle from "./components/handle";
import Cookies from "js-cookie";
import LoginProvider, { useLoginStore } from "@/providers/login/login.provider";
import NameEmail from "./components/name_email";
import SetDynamicHeight from "./components/setDynamicHeight";

export enum AnimationType {
  SLIDEINRIGHT,
  SLIDEINLEFT,
  SLIDEDOWN,
}

const RenderPage = ({ close }: { close: () => void }) => {
  const step = useLoginStore((state) => state.step);
  switch (step) {
    case LoginStep.PHONE:
      return (
        <Phone
          back={() => {
            close();
            Cookies.remove("PayJoinLogin");
          }}
        />
      );
    case LoginStep.OTP:
      return (
        <Otp
          close={() => {
            close();
          }}
        />
      );
    case LoginStep.NAME:
      return <Name />;
    case LoginStep.EMAIL:
      return <Email />;
    case LoginStep.NAME_EMAIL:
      return <NameEmail />;
    case LoginStep.HANDLE:
      return (
        <Handle
          close={() => {
            close();
          }}
        />
      );
    default:
      return <></>;
  }
};

const LoginModal = (
  {}: LoginPropsType,
  ref: React.Ref<unknown> | undefined
) => {
  const [show, setShow] = useState<boolean>(false);
  const setVisibility = useCallback((status: boolean) => {
    setShow(status);
  }, []);

  useImperativeHandle(ref, () => ({
    setVisibility,
  }));

  return (
    <Modal show={show} onClose={() => {}}>
      <RenderPage
        close={() => {
          setShow(false);
        }}
      />
      <SetDynamicHeight />
    </Modal>
  );
};

export default forwardRef(LoginModal);
